import route from "@/components/router/Router"
import messagesChild from "./messages/index"

export default {
    path : "usercenter",
    name : "usercenter",
    meta : {
        title : "个人中心",
    },
    redirect : {
        name : "usercenter-info",
    },
    component: route,
    children : [
        {
            path: 'info',
            name: 'usercenter-info',
            meta: {
                title: '个人信息-个人中心'
            },
            component: () => import("@/pages/usercenter/info/Info"),
        },
        {
            path: 'password',
            name: 'usercenter-password',
            meta: {
                title: '密码修改-个人中心'
            },
            component: () => import("@/pages/usercenter/password/Password"),
        },
        {
            path: 'images',
            name: 'usercenter-images',
            meta: {
                title: '附件相机库-个人中心'
            },
            component: () => import("@/pages/usercenter/images/Images"),
        },
        {
            path: 'business-cards',
            name: 'usercenter-business-cards',
            meta: {
                title: '查看名片统计-个人中心'
            },
            component: () => import("@/pages/usercenter/businessCards/List"),
        },
        {
            path: 'messages',
            name: 'usercenter-messages',
            meta: {
                title: '消息列表-个人中心'
            },
            component: () => import("@/pages/usercenter/messages/Index"),
            redirect: {
                name : "usercenter-messages-system",
            },
            children: messagesChild
        }
    ],
}


// WEBPACK FOOTER //
// ./src/router/usercenter/indexRouter.js